import { render } from "./eventModal.vue?vue&type=template&id=07d68cb4&scoped=true&ts=true"
import script from "./eventModal.vue?vue&type=script&lang=ts"
export * from "./eventModal.vue?vue&type=script&lang=ts"

import "./eventModal.vue?vue&type=style&index=0&id=07d68cb4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d68cb4"]])

export default __exports__